/**
 * Loading spinner for the cart drawer.
 *
 * Shown while a line is being added, removed or re-quantified, and cleared once
 * the cart has come back and the drawer has re-rendered.
 *
 * Busy is detected two ways, because the two paths signal differently:
 *   1. The theme's own cart mutations add `cart-items-disabled` to the cart items
 *      component for the duration of the request (see component-cart-items.js).
 *      A MutationObserver on class changes picks that up without patching theme JS.
 *   2. Quick Add fetches /cart/add.js directly and never touches that class, so
 *      its clicks are tracked here and released on the next `cart:update`.
 *
 * A hard timeout backstops both. A spinner that gets stuck on is worse than one
 * that never appears, so it always clears itself.
 */
(function () {
  if (window.__mimuCartSpinner) return;
  window.__mimuCartSpinner = true;

  var QUICK_ADD_TIMEOUT = 8000;
  var quickAddBusy = false;
  var quickAddTimer = null;
  var node = null;

  function host() {
    return document.querySelector('.cart-drawer__dialog');
  }

  function ensure() {
    var h = host();
    if (!h) return null;
    if (!node || !node.isConnected) {
      node = h.querySelector('[data-mimu-spinner]');
      if (!node) {
        node = document.createElement('div');
        node.className = 'mimu-spin';
        node.setAttribute('data-mimu-spinner', '');
        // Announced rather than hidden: a screen reader should know the cart is
        // working, but the ring itself is decorative.
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        node.innerHTML =
          '<span class="mimu-spin__ring" aria-hidden="true"></span>' +
          '<span class="visually-hidden">Updating your cart</span>';
        h.appendChild(node);
      }
    }
    return node;
  }

  function themeBusy() {
    return !!document.querySelector('.cart-items-disabled');
  }

  function sync() {
    var el = ensure();
    if (!el) return;
    el.classList.toggle('is-on', themeBusy() || quickAddBusy);
  }

  function releaseQuickAdd() {
    quickAddBusy = false;
    clearTimeout(quickAddTimer);
    sync();
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest ? event.target.closest('[data-mimu-qa-add]') : null;
      if (!btn) return;
      quickAddBusy = true;
      clearTimeout(quickAddTimer);
      quickAddTimer = setTimeout(releaseQuickAdd, QUICK_ADD_TIMEOUT);
      sync();
    },
    true
  );

  // The drawer re-renders on cart:update, so this is the moment the new state is
  // on screen and the spinner has done its job.
  document.addEventListener('cart:update', function () {
    setTimeout(releaseQuickAdd, 60);
  });

  new MutationObserver(sync).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });

  sync();
})();
